import api from "./api";

export const getServiceFee = async () => {
  return api
    .get({
      endpoint: "/c/one?q=SERVICE_FEE",
      port: process.env.REACT_APP_PORT_VENUE,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
